module.exports = __webpack_public_path__ + "img/booleantv-mobile.2179e63a.png";